import React, { useEffect, useMemo, useState } from 'react';
import {
  addProductToWishList,
  removeProductFromWishList,
  WishListActions,
} from '../../Reducers/WishList.reducer';
import { useDispatch } from 'react-redux';
import Product from '../../Types/Product';
import Icon from '../Icon';
import clsx from 'clsx';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const FavoriteButton = ({
  product,
  className,
  iconClassName,
  iconWrapperClassName,
}: {
  className?: string;
  iconClassName?: string;
  iconWrapperClassName?: string;
  product: Product;
}) => {
  const dispatch = useDispatch();
  const { current } = useTypedSelector((state) => state.userInfo);
  const { favorite } = product;

  const [isFavorite, setIsFavorite] = useState<boolean>(favorite);

  const onClick = () => {
    if (isFavorite) {
      dispatch(removeProductFromWishList(product));
      dispatch(WishListActions.removeWishListItem({ product: product }));
    } else {
      dispatch(addProductToWishList(product));
    }
    setIsFavorite(!isFavorite);
  };

  return current ? (
    <button
      className={clsx(
        className
          ? className
          : isFavorite
          ? 'duration-600 group absolute right-0 top-0 z-10 p-2 transition-all group-hover:top-0 group-focus:top-0'
          : 'duration-600 group absolute right-0 top-0 z-10 p-2 transition-all group-hover:top-0 group-focus:top-0 lg:-top-1'
      )}
      onClick={onClick}
    >
      <div
        className={clsx(
          iconWrapperClassName
            ? iconWrapperClassName
            : isFavorite
            ? 'duration-600 flex h-6 w-6 items-center justify-center rounded-full bg-opacity-white-90 transition-all lg:h-8 lg:w-8'
            : 'duration-600 flex h-6 w-6 items-center justify-center rounded-full bg-opacity-white-90 transition-all group-hover:opacity-100 group-focus:opacity-100 lg:h-8 lg:w-8 lg:opacity-0'
        )}
      >
        <Icon
          name={isFavorite ? 'heart-filled' : 'heart'}
          className={clsx(
            iconClassName,
            !iconClassName && 'h-4 w-4',
            !iconClassName && isFavorite && 'text-success-300'
          )}
        />
      </div>
    </button>
  ) : null;
};

export default FavoriteButton;
